// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/.dumi/pages/weet/design-tokens.tsx?type=frontmatter';
import { frontmatter as fm1, toc as t1 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/.dumi/pages/weet/icon-libs.tsx?type=frontmatter';
import { frontmatter as fm2, toc as t2 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/.dumi/pages/index.tsx?type=frontmatter';
import { frontmatter as fm3, toc as t3 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet-icons.md?type=frontmatter';
import { demoIndex as dmi3 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet-icons.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet-icons.md?type=frontmatter';
import { demoIndex as dmi4 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet-icons.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input-number.md?type=frontmatter';
import { demoIndex as dmi5 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input-number.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/index.md?type=frontmatter';
import { demoIndex as dmi6 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/index.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet.md?type=frontmatter';
import { demoIndex as dmi7 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet.md?type=frontmatter';
import { demoIndex as dmi8 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/checkbox.md?type=frontmatter';
import { demoIndex as dmi9 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/checkbox.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/ee-grid.md?type=frontmatter';
import { demoIndex as dmi10 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/ee-grid.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tooltip.md?type=frontmatter';
import { demoIndex as dmi11 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tooltip.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/avatar.md?type=frontmatter';
import { demoIndex as dmi12 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/avatar.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/button.md?type=frontmatter';
import { demoIndex as dmi13 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/button.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/result.md?type=frontmatter';
import { demoIndex as dmi14 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/result.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/switch.md?type=frontmatter';
import { demoIndex as dmi15 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/switch.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/badge.md?type=frontmatter';
import { demoIndex as dmi16 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/badge.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/empty.md?type=frontmatter';
import { demoIndex as dmi17 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/empty.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/icons.md?type=frontmatter';
import { demoIndex as dmi18 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/icons.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input.md?type=frontmatter';
import { demoIndex as dmi19 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/radio.md?type=frontmatter';
import { demoIndex as dmi20 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/radio.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/toast.md?type=frontmatter';
import { demoIndex as dmi21 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/toast.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/antd.md?type=frontmatter';
import { demoIndex as dmi22 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/antd.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tag.md?type=frontmatter';
import { demoIndex as dmi23 } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tag.md?type=demo-index';

export const filesMeta = {
  'weet/design-tokens': {
    frontmatter: fm0,
    toc: t0,
  },
  'weet/icon-libs': {
    frontmatter: fm1,
    toc: t1,
  },
  'index': {
    frontmatter: fm2,
    toc: t2,
  },
  'docs/contribute/weet-icons': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet-icons.md?type=text'),
  },
  'docs/changelog/weet-icons': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet-icons.md?type=text'),
  },
  'docs/weet/input-number': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input-number.md?type=text'),
  },
  'docs/contribute/index': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/index.md?type=text'),
  },
  'docs/contribute/weet': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/weet.md?type=text'),
  },
  'docs/changelog/weet': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/changelog/weet.md?type=text'),
  },
  'docs/weet/checkbox': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/checkbox.md?type=text'),
  },
  'docs/weet/ee-grid': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/ee-grid.md?type=text'),
  },
  'docs/weet/tooltip': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tooltip.md?type=text'),
  },
  'docs/weet/avatar': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/avatar.md?type=text'),
  },
  'docs/weet/button': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/button.md?type=text'),
  },
  'docs/weet/result': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/result.md?type=text'),
  },
  'docs/weet/switch': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/switch.md?type=text'),
  },
  'docs/weet/badge': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/badge.md?type=text'),
  },
  'docs/weet/empty': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/empty.md?type=text'),
  },
  'docs/weet/icons': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/icons.md?type=text'),
  },
  'docs/weet/input': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input.md?type=text'),
  },
  'docs/weet/radio': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/radio.md?type=text'),
  },
  'docs/weet/toast': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/toast.md?type=text'),
  },
  'docs/weet/antd': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/antd.md?type=text'),
  },
  'docs/weet/tag': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tag.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
